import { RouteComponentProps } from 'react-router';
import { withTranslation, WithTranslation } from 'react-i18next';
import { BrokerModel, SupplierModel } from '../../../../api/admin/admin.types';
import { PageRequest } from '../../../../api/api.types';
import { AppState } from '../../../../store/store.types';
import { ThunkDispatch } from 'redux-thunk';
import { connect } from 'react-redux';
import { BrokerActionTypes } from '../../types/broker.types';
import { getBrokerList } from '../../actions/broker.actions';
import React from 'react';
import StatusLabel from '../../../../components/forms/StatusLabel';
import { Link } from 'react-router-dom';
import ListViewTable from '../../../../components/tables/ListViewTable';
import { UncontrolledTooltip as Tooltip } from 'reactstrap';

interface BrokerProps extends RouteComponentProps, WithTranslation {
  getBrokerList: (pageRequest?: PageRequest) => void;
  brokers: BrokerModel[] | null;
  suppliers: SupplierModel[];

}

interface BrokerState {
  selectedPageNumber: number;
  sortOrder: 'ASC' | 'DESC';
  sortedBy: string;
}

class Brokers extends React.Component<BrokerProps, BrokerState> {
  constructor(props: BrokerProps) {
    super(props);
    this.state = {
      selectedPageNumber: 1,
      sortOrder: 'ASC',
      sortedBy: 'code'
    };
  }

  componentDidMount() {
    this.props.getBrokerList();
  }

  statusCell = (props: any) => (<StatusLabel status={props}/>);

  onRowClick = (rowInfo: any) =>
    this.props.history.push(`/admin/manage-brokers/${rowInfo.original.id}/view`);

  supplierCell = ({ row }: { row: any }) => {
    const { t } = this.props;

    const supplierList: JSX.Element[] = [];
    row.original.supplierCodes.forEach((supplierCode: any) => {
      const supplierObj = this.props.suppliers.find(supplier => supplier.code === supplierCode);
      if (supplierObj) {
        supplierList.push(
          <div
            key={supplierCode}
            className="p-0"
          >
            {supplierObj?.name}
          </div>
        );
      }
    });

    if (supplierList.length > 0) {
      if (supplierList.length === 1) {
        return supplierList[ 0 ];
      }
      return (
        <>
          <div
            className="btn btn-link font-normal p-0"
            id={`suppliers-tooltip-${row.original.id}`}
          >
            {t('v.notifications.suppliers', { count: supplierList.length })}
          </div>
          <Tooltip
            modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
            placement="top"
            target={`suppliers-tooltip-${row.original.id}`}
            autohide={false}
          >
            {supplierList}
          </Tooltip></>
      );
    }
    return t('v.notifications.all_suppliers');
  };

  defineColumns() {
    const { t } = this.props;
    return [
      {
        header: t('ct.brokers.name'), accessorKey: 'name', id: 'name'
      },
      {
        header: t('ct.brokers.legal_name'), accessorKey: 'legalName', id: 'legalName'
      },
      {
        header: t('ct.brokers.status_type'),
        accessorKey: 'statusType',
        id: 'statusType',
        cell: (info: any) => this.statusCell(info.getValue())
      },
      {
        header: t('ct.brokers.comment'), accessorKey: 'comment', id: 'comment'
      },
      {
        header: 'Suppliers',
        accessorKey: 'suppliers',
        id: 'suppliers',
        cell: ({ row }: { row: any }) => this.supplierCell({ row })
      }
    ];
  }


  render() {

    const { t } = this.props;
    return (
      <main>
        <div className="page-content">
          <div className="d-flex justify-content-between align-items-center mt-2 mb-1">
            <h1>{t('page_title.brokers')}</h1>
            <Link
              to={{
                pathname: '/admin/manage-brokers/create'
              }}
              className="btn btn-primary btn-wide"
            >
              {t('b.add_new').toUpperCase()}
            </Link>
          </div>
          {this.props.brokers?.length ? (
            <div className="table-list">
              <ListViewTable
                data={this.props.brokers}
                columns={this.defineColumns()}
                getTrProps={this.onRowClick}/>
            </div>
          ) : ''}
        </div>
      </main>

    );
  }
}

const mapStateToProps = (state: AppState) => ({
  brokers: state.admin.brokers.brokers,
  suppliers: state.authentication.suppliers,
  totalPages: state.admin.classifiers.totalPages,
  totalElements: state.admin.classifiers.totalElements
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, BrokerActionTypes>) => ({
  getBrokerList: (pageRequest?: PageRequest) => dispatch(getBrokerList(pageRequest))
});

export default withTranslation()(connect(
  mapStateToProps,
  mapDispatchToProps
)(Brokers));